function orderSummary() {

    $(document).on("click", '#btn-order-summary', function() {
        $(this).toggleClass('open')
        $(this).parents('.order-summary--header').siblings('.order-summary--body').slideToggle()
    })
}

$(document).ready( function() {
    orderSummary()
})
